module.exports = __webpack_public_path__ + "img/magento-version-switching_small@2x.27dbe3b3.jpg";